const BhVampLock = (props) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 1.125C4.61929 1.125 3.5 2.24429 3.5 3.625V4.5H2.875C2.39175 4.5 2 4.89175 2 5.375V10.125C2 10.6082 2.39175 11 2.875 11H9.125C9.60825 11 10 10.6082 10 10.125V5.375C10 4.89175 9.60825 4.5 9.125 4.5H8.5V3.625C8.5 2.24429 7.38071 1.125 6 1.125ZM7.75 4.5V3.625C7.75 2.6585 6.9665 1.875 6 1.875C5.0335 1.875 4.25 2.6585 4.25 3.625V4.5H7.75ZM6 6.625C6.20711 6.625 6.375 6.79289 6.375 7V8.5C6.375 8.70711 6.20711 8.875 6 8.875C5.79289 8.875 5.625 8.70711 5.625 8.5V7C5.625 6.79289 5.79289 6.625 6 6.625Z"
      fill="currentColor"
    />
  </svg>
)

export default BhVampLock
